import React, { useEffect } from "react";
import {
  Switch,
  Route,
  useHistory,
  useRouteMatch,
  Redirect,
} from "react-router-dom";
import BaseLayout from "../../components/layouts/BaseLayout";
import VehicleParametersWidget from "./widgets/VehicleParametersWidget";
import EmailTemplates from "./emailTemplates/EmailTemplates";
import useSetState from "../../hooks/useSetState";
import { TabInterface } from "../../interfaces/tab-interface";

const Settings: React.FC = () => {
  const history = useHistory();
  const [{ activeTab }, setState] = useSetState({ activeTab: "general" });

  const tabs: TabInterface[] = [
    { label: "General", value: "general" },
    { label: "Email Templates", value: "email" },
  ];

  const match = useRouteMatch({
    path: "/settings/:activeTabURL",
    strict: true,
    sensitive: true,
  });
  const { activeTabURL } = match?.params as any;

  const handleTabClick = (event, newValue): void => {
    history.push(`/settings/${newValue}`);
    setState({ activeTab: newValue });
  };

  useEffect(() => {
    setState({ activeTab: activeTabURL });
  }, []);

  return (
    <BaseLayout
      title="Settings"
      tabs={tabs}
      handleTabChange={handleTabClick}
      activeTab={activeTab}
    >
      <Switch>
        <Route path="/settings/general" exact>
          <VehicleParametersWidget />
        </Route>
        <Route path="/settings/email" exact>
          <EmailTemplates />
        </Route>
        <Redirect to="/settings/general" />
      </Switch>
    </BaseLayout>
  );
};

export default Settings;
